var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-box"},[_c('i',{staticClass:"iconfont glin-shuangjiantoushang",on:{"click":function($event){return _vm.handleScroll(0, 300)}}}),_vm._v(" "),_c('i',{staticClass:"iconfont glin-qingchu",on:{"click":function($event){return _vm.handleClear()}}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e51e47b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/backTop.vue
// module id = null
// module chunks = 